export default "<router-outlet></router-outlet>\n\n\n";